


















import Vue from 'vue';

export enum DropdownType {
  default = 'default',
  withChecks = 'withChecks',
  places = 'places',
}

export default Vue.extend({
  name: 'Dropdown',
  props: {
    items: {
      default: () => [],
      type: Array,
    },
    selectedItem: String,
    active: Boolean,
    dropdownType: {
      type: String,
      default: 'default',
    },
    hasBeak: Boolean,
  },
  data() {
    return {
      DropdownType,
    };
  },
});
